import { computed } from 'vue'
import {
  useNotificationsStore,
  type NotificationToastInput,
  type ConfirmDialogInput
} from '@/stores/notifications'

export function useNotify() {
  const store = useNotificationsStore()

  const toasts = computed(() => store.toasts)

  const push = (toast: NotificationToastInput) => store.pushToast(toast)
  const dismiss = (id: string) => store.dismissToast(id)
  const clear = () => store.clearToasts()

  const success = (title: string, message?: string, options?: Partial<NotificationToastInput>) =>
    push({ type: 'success', title, message, ...options })

  const error = (title: string, message?: string, options?: Partial<NotificationToastInput>) =>
    push({ type: 'error', title, message, persistent: true, ...options })

  const warning = (title: string, message?: string, options?: Partial<NotificationToastInput>) =>
    push({ type: 'warning', title, message, ...options })

  const info = (title: string, message?: string, options?: Partial<NotificationToastInput>) =>
    push({ type: 'info', title, message, ...options })

  const progress = (title: string, message?: string, progressValue?: number, options?: Partial<NotificationToastInput>) =>
    push({ type: 'progress', title, message, progress: progressValue, persistent: true, ...options })

  const confirm = (options: ConfirmDialogInput) => store.showDialog(options)

  return {
    toasts,
    push,
    dismiss,
    clear,
    success,
    error,
    warning,
    info,
    progress,
    confirm
  }
}
